
const leftArrow = <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20"><path d="m10 16.542-6.521-6.521L10 3.5l1.562 1.583-3.833 3.834h8.792v2.187H7.729l3.833 3.854Z" /></svg>

const rightArrow = <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20"><path d="m10 16.542-1.458-1.48 4.02-4.02H3.479V9h9.083l-4.02-4.021L10 3.5l6.521 6.521Z" /></svg>


const expandMore = <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 96 960 960" width="40"><path d="M480 697.537 253.847 471.385l35.794-35.794L480 626.36l190.359-190.359 35.794 35.794L480 697.537Z"/></svg>

const expandLess = <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 96 960 960" width="40"><path d="m289.641 697.537-35.794-35.793L480 435.591l226.153 225.742-35.794 35.794L480 506.768 289.641 697.537Z"/></svg>
export {leftArrow, rightArrow, expandMore, expandLess}